/**
** JAVASCRIPTS
** Name: Form Validation
********************************************************************************/

const formsRecaptcha = [];
const $emailInputs = document.querySelectorAll('input[type="email"]');
const $submitsRecaptcha = document.querySelectorAll('.g-recaptcha[data-form-id]');

// Inject reCaptcha once by removing listeners after first focusin
const handleFormFocusIn = (e) => {
  if (!window.recaptcha) {
    const scriptElement = document.createElement('script');
    scriptElement.src = "https://www.google.com/recaptcha/api.js?hl=fr";
    scriptElement.async = true;
    document.body.appendChild(scriptElement);
  }

  formsRecaptcha.forEach(($formRecaptcha) => {
    $formRecaptcha.removeEventListener('focusin', handleFormFocusIn);
  });
}

// Add custom client message with example when email is invalid
if ($emailInputs.length > 0) {
  $emailInputs.forEach(($emailInput) => {
    $emailInput.addEventListener('input', () => {
      $emailInput.setCustomValidity('');
      $emailInput.checkValidity();
    });

    $emailInput.addEventListener('invalid', () => {
      if ($emailInput.value === '') {
        $emailInput.setCustomValidity('');
      } else {
        $emailInput.setCustomValidity('Veuillez saisir une adresse email valide. Par exemple, nom@domaine.fr');
      }
    });
  });
}

// Add listener on form with reCaptcha needed
if ($submitsRecaptcha.length > 0 && !window.recaptcha) {
  $submitsRecaptcha.forEach(($submitRecaptcha) => {
    const $form = document.getElementById($submitRecaptcha.dataset.formId);
    if($form) {
      $form.addEventListener('focusin', handleFormFocusIn);
      formsRecaptcha.push($form);
    }
  });
}
